// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalQRCode .modal-dialog {
    transform: translate(0,0) !important;
}

.QrTitle {
    font-family: OpenSans;
    font-weight: 300;
    font-size: 32px;
    color: var(--main-link-color);
    margin-top: 0;
    margin-bottom: 0;
    line-height: 60px;
    margin-bottom: 22px;
}

.ModalQRCode .chevronBack {
    width: 100%;
}

.ModalQRCode .modal-backdrop {
    display: block !important;
}

#newButtonScan {
    min-height: 40px;
    /*color: var(--footer-selected-color);*/
    font-size: 12px;
    letter-spacing: 1.2px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 0;
    font-family: OpenSans;
    align-items: center;
    background-color: #FF9E17;
    text-transform: uppercase;
    margin-top: 20px;
    cursor: pointer;
    border: none;
    max-width: 50%;
    margin: 0 auto;
    margin-bottom: 25px;
}

#newSerialNumber {
    margin-bottom: 25px;
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 50%;
    margin: 0 auto;
    margin-top: 25px
}
#inputName {
    /*margin-bottom: 25px;*/
    /*display: flex;*/
    /*justify-content: center;*/
    /*width: 100%;*/
    /*max-width: 50%;*/
    /*margin: 0 auto;*/
    /*margin-top: 25px*/
}
.buttonaddPorduct {
    margin-bottom: 25px;
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 50%;
    margin: 0 auto;
    margin-top: 25px;
    border: 0;
    background: #FF9E17;
    min-height: 23px;
    align-items: center;
    font-size: 11px;
}

.ModalQRCode .closeModal {
    position: absolute;
    right: 15px;
    top: 10px;
}

.qrcodesvg section div {
    padding-top: 60% !important;
}

@media (max-width: 600px) {
    .qrModal {
        margin: auto;
    }
}

.topQrModal {
    margin-bottom: 5px;
    min-height: 60px;
    display: flex;
    justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/App/css/QRCode.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,uCAAuC;IACvC,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,cAAc;IACd,cAAc;IACd;AACJ;AACA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC","sourcesContent":[".ModalQRCode .modal-dialog {\n    transform: translate(0,0) !important;\n}\n\n.QrTitle {\n    font-family: OpenSans;\n    font-weight: 300;\n    font-size: 32px;\n    color: var(--main-link-color);\n    margin-top: 0;\n    margin-bottom: 0;\n    line-height: 60px;\n    margin-bottom: 22px;\n}\n\n.ModalQRCode .chevronBack {\n    width: 100%;\n}\n\n.ModalQRCode .modal-backdrop {\n    display: block !important;\n}\n\n#newButtonScan {\n    min-height: 40px;\n    /*color: var(--footer-selected-color);*/\n    font-size: 12px;\n    letter-spacing: 1.2px;\n    font-weight: bold;\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    padding: 0;\n    font-family: OpenSans;\n    align-items: center;\n    background-color: #FF9E17;\n    text-transform: uppercase;\n    margin-top: 20px;\n    cursor: pointer;\n    border: none;\n    max-width: 50%;\n    margin: 0 auto;\n    margin-bottom: 25px;\n}\n\n#newSerialNumber {\n    margin-bottom: 25px;\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    max-width: 50%;\n    margin: 0 auto;\n    margin-top: 25px\n}\n#inputName {\n    /*margin-bottom: 25px;*/\n    /*display: flex;*/\n    /*justify-content: center;*/\n    /*width: 100%;*/\n    /*max-width: 50%;*/\n    /*margin: 0 auto;*/\n    /*margin-top: 25px*/\n}\n.buttonaddPorduct {\n    margin-bottom: 25px;\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    max-width: 50%;\n    margin: 0 auto;\n    margin-top: 25px;\n    border: 0;\n    background: #FF9E17;\n    min-height: 23px;\n    align-items: center;\n    font-size: 11px;\n}\n\n.ModalQRCode .closeModal {\n    position: absolute;\n    right: 15px;\n    top: 10px;\n}\n\n.qrcodesvg section div {\n    padding-top: 60% !important;\n}\n\n@media (max-width: 600px) {\n    .qrModal {\n        margin: auto;\n    }\n}\n\n.topQrModal {\n    margin-bottom: 5px;\n    min-height: 60px;\n    display: flex;\n    justify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
